import moment from "moment";

const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

function convertToAMPM(dateString: string) {
  const parsedDate = moment(dateString, "HH:mm:ss [GMT]ZZ");
  const timeString = parsedDate.format("hh:mm a");
  return timeString;
}
function calculateAge(dateOfBirth: string): number {
  const dob = new Date(dateOfBirth);
  const now = new Date();

  // Get the difference in years
  let age = now.getFullYear() - dob.getFullYear();

  // Check if the birthday has occurred this year
  const hasBirthdayOccurred =
    now.getMonth() > dob.getMonth() ||
    (now.getMonth() === dob.getMonth() && now.getDate() >= dob.getDate());

  // If the birthday hasn't occurred yet this year, subtract one year
  if (!hasBirthdayOccurred) {
    age--;
  }

  return age;
}

function convertDate(dateString: any) {
  const date = new Date(dateString);
  const dayOfWeek = date.toLocaleDateString("en-US", { weekday: "short" });
  const month = monthNames[date.getMonth()];
  const dayOfMonth = date.getDate();
  const formattedDate = `${dayOfWeek}, ${month} ${dayOfMonth}`;
  return formattedDate;
}

const getAllDates = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();
  const day = today.getDate();

  const allDates = [];
  let currentDate = new Date(year, month, day);

  for (let i = 0; i < 3; i++) {
    const totalDaysInMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    ).getDate();

    for (let j = currentDate.getDate(); j <= totalDaysInMonth; j++) {
      const date = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        j
      );
      const formattedDate = formatDate(date);
      allDates.push(formattedDate);
    }

    currentDate.setMonth(currentDate.getMonth() + 1);
    currentDate.setDate(1);
  }

  return allDates;
};

const formatDate = (date: any) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export { convertToAMPM, convertDate, getAllDates, calculateAge };
